/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/* eslint-disable @typescript-eslint/no-unsafe-return */
/* eslint-disable @typescript-eslint/no-unsafe-assignment */
import Spanish from 'flatpickr/dist/l10n/es';
import moment, { Moment } from 'moment-timezone';

export const TIMEZONE = 'Europe/Madrid';
export const INTERVAL_MIN = 15;
export const FLAT_PICKER_DATE_TIME_FORMAT = 'd/m/Y H:i';
export const DATE_FORMAT = 'DD/MM/YYYY';
export const BETWEEN_FORMAT = 'YYYY/MM/DD';
export const SQL_FORMAT = 'YYYY/MM/DD HH:mm:ss';
export const TIME_FORMAT = 'HH:mm';
export const DATE_TIME_FORMAT = 'DD/MM/YYYY HH:mm:ss';
export const VEHICLE_KM_FORMAT = 'YYYY-MM-DD HH:mm:ss';
export const DATE_PICKER_DEFAULT_CONFIG: any = {
  dateFormat: FLAT_PICKER_DATE_TIME_FORMAT,
  locale: Spanish.es,
  altInputClass: 'warning',
  minDate: moment().toDate(),
  disableMobile: true,
  position: 'auto center',
};

export const getSpanishTimezoneUTC = (reservationDate: string): string => {
  const date = moment(reservationDate).tz(TIMEZONE).format('ZZ');
  return date;

  /* Incompatibility with some browsers. Crash.
  const formatter = new Intl.DateTimeFormat([], {
    timeZone: 'Europe/Madrid',
    timeZoneName: 'longOffset',
  });

  return (
    formatter
      .formatToParts(Date.now())
      // eslint-disable-next-line @typescript-eslint/typedef
      .find((formatted) => formatted.type === 'timeZoneName')
      ['value'].substring(3)
  );*/
};

export function getStartDate(): string {
  const date = getInitialDate();

  return date.add(1, 'day').format(DATE_TIME_FORMAT);
}

export function getEndDate(): string {
  const date = getInitialDate();

  return date.add(2, 'day').format(DATE_TIME_FORMAT);
}

export function getInitialDate(): Moment {
  const now = moment().add(INTERVAL_MIN, 'minutes');
  return now.minutes(Math.floor(now.minutes() / INTERVAL_MIN) * INTERVAL_MIN);
}

export function getFormattedDateFromParams(date: string): string {
  const m = moment(date, SQL_FORMAT);
  return m.isValid() ? m.format() : null;
}

export function getEndDateFromStartDateInput(startDate: string): string {
  const date = moment(startDate, DATE_TIME_FORMAT);
  return date.add(1, 'day').format('DD/MM/YYYY HH:mm');
}
